// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Gz-5b","form":"styles_form__uG2g3","disclaimer":"styles_disclaimer__qpW04","formTabs":"styles_formTabs__u5NCD"};